export default __webpack_public_path__ + "static/green_initiative_forests_by_heartfulness_1-79fd7ca864fc2809ca4d0471de37473c.png";